import { auth } from './firebase';
import { authReady } from './dicomService';

/**
 * A current Firebase ID token. Tokens expire after an hour; the stored copy is only refreshed
 * when an API call fails with 401, so a plain link built from localStorage (as the ZIP
 * download used to be) fails silently for anyone who has had the page open a while.
 */
export async function freshIdToken(): Promise<string | null> {
  try {
    await authReady();
    const token = await auth.currentUser?.getIdToken();
    if (token) {
      localStorage.setItem('firebase_id_token', token);
      return token;
    }
  } catch {
    /* fall back to the stored token */
  }
  return localStorage.getItem('firebase_id_token');
}

const apiBase = () => (process.env.REACT_APP_API_MAIN_URL || '').replace(/\/$/, '');

/** Hand a URL to the browser as a file download without leaving the page. */
export function saveFromUrl(url: string, filename?: string): void {
  const a = document.createElement('a');
  a.href = url;
  if (filename) a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * Start the study ZIP download. The API streams the archive as it is built, so the browser's
 * download bar shows progress right away.
 */
export async function downloadStudyZip(studyUuid: string): Promise<void> {
  const token = await freshIdToken();
  const url = `${apiBase()}/api/v1/dicoms/study/${encodeURIComponent(studyUuid)}/download-zip?token=${encodeURIComponent(token ?? '')}`;
  saveFromUrl(url);
}
